import React, { useContext } from 'react';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
import { isProduct, isInGroupSuggestion, isSearchSuggestion } from '../../../typeGuards';
import SectionItemText from './SectionItemText';
import { translate } from '../../../utils/helpers';
import SearchSuggestionItem from './SearchSuggestionItem';
export default function SectionItem(props) {
    const { item, children, displaySearchTermHighlights } = props;
    const { getItemProps, advancedParameters, query, getSearchResultsUrl } = useContext(CioAutocompleteContext);
    const { translations } = advancedParameters || {};
    let defaultChildren;
    if (isProduct(item)) {
        defaultChildren = (React.createElement("a", { href: item.data?.url },
            React.createElement("img", { "data-testid": 'cio-img', src: item.data?.image_url, alt: item.value, className: 'cio-product-image' }),
            React.createElement("p", { "data-testid": 'cio-text', className: 'cio-product-text' },
                React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights }))));
    }
    else if (isInGroupSuggestion(item)) {
        defaultChildren = (React.createElement("p", { className: 'cio-term-in-group' },
            translate('in', translations),
            ' ',
            React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })));
    }
    else if (isSearchSuggestion(item)) {
        if (getSearchResultsUrl) {
            defaultChildren = (React.createElement("a", { className: 'suggestion-link', href: getSearchResultsUrl(item) },
                React.createElement(SearchSuggestionItem, { item: item, displaySearchTermHighlights: displaySearchTermHighlights })));
        }
        else {
            defaultChildren = (React.createElement(SearchSuggestionItem, { item: item, displaySearchTermHighlights: displaySearchTermHighlights }));
        }
    }
    else {
        defaultChildren = (React.createElement("p", { className: 'cio-custom-text' },
            React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })));
    }
    return React.createElement("li", { ...getItemProps(item) }, children || defaultChildren);
}
